import { createService, z } from '@bonanza-social/toolkit/api';
import { InboxResponseSchema } from './InboxService.schemas';

export default createService(
  {
    getInbox: {
      method: 'GET',
      url: '/inbox',
      responseSchema: InboxResponseSchema,
      headers: {
        'x-Feature-Metagame-Inbox-Notifications': true,
      },
    },
    acknowledgeInbox: {
      method: 'PATCH',
      url: '/inbox',
      responseSchema: z.object({}).optional(),
    },
    smarticoSmarticoNotificationClicked: {
      method: 'POST',
      url: ({ id }: { id: number }) => `/inbox/${id}/click`,
      responseSchema: z.void(),
    },
  },
  ({ userId }) => `/notifications/Players/${userId}`,
);
